<template>
    <div :class="`metric --${this.className}`">
        <div class="metric__savings">
            <transition name="transition --switch-loader-fade">
                <div v-if="loading"
                     class="metric__savings__loading">
                    <i class="metric__savings__loading__icon fas fa-cog fa-spin" />
                </div>
            </transition>
            <transition name="transition --switch-loader-fade">
                <div v-if="!loading"
                     class="metric__savings__value">
                    {{ saving }}
                </div>
            </transition>
            <div v-if="isSapMetric"
                 class="metric__savings__sap-change">
                ({{ sapChange }})
            </div>
            <div v-else-if="hasWorsened"
                 class="metric__savings__warning">
                <i class="fas fa-exclamation-triangle" />
            </div>
            <div v-else
                 class="metric__savings__percentage">
                ({{ percentageSaving }})
            </div>
        </div>
        <div :class="`metric__description${this.hasWorsened ? ' --error' : ''}`">
            {{ descriptionText }}
        </div>
    </div>
</template>

<script>

import METRIC_KEYS from '@/models/METRIC_KEYS'

import MetricDisplay from '@/components/metric-display'

export default {

    mixins: [
        MetricDisplay,
    ],

    computed: {

        /**
         * @returns {string}
         */
        descriptionText() {
            switch (this.metric.key){
                case METRIC_KEYS.carbonSaving:
                    return `estimated tonnes CO₂ ${ this.hasWorsened ? 'increased' : 'saved' } annually`
                case METRIC_KEYS.fuelBill:
                    return `estimated annual fuel bill ${ this.hasWorsened ? 'increase' : 'saving' }`
                case METRIC_KEYS.sapScore:
                    return 'estimated SAP score'
                default:
                    return `${ this.metric.name } ${ this.hasWorsened ? 'degradation' : 'improvement' }`
            }
        },

        /**
         * @returns {string}
         */
        saving() {
            return this.isSapMetric
                ? `SAP ${ this.sapRating }`
                : this.metric.saving
                    ? this.metric.saving.display.replace('-', '').replace(' tCO₂', '')
                    : ' - '
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\app-core\_metric.scss

.metric {
    display: table;
    width: 100%;

    > * {
        display: table-cell;
        vertical-align: middle;
        padding: 0.6rem 0.1rem;
    }

    @include element('savings') {
        width: 40%;
        text-align: center;

        @include element('loading') {
            font-size: 1.6rem;
            line-height: 1.8rem;
            opacity: 1;
        }

        @include element('value') {
            font-size: 1.5rem;
            line-height: 1.8rem;
            opacity: 1;
        }
    }

    @include element ('description') {
        font-size: 0.9rem;
        width: 60%;
        font-weight: bold;
        text-align: left;
    }
}

</style>
